import "./ContactUs.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";

const ContactUs = ({ onClose }) => {
  return (
    <div className="contactus" onClick={onClose}>
      <div className="contactus-content">
        <div className="cuclose-button">
          <button onClick={onClose}>&#10006;</button>
        </div>

        <div className="contactus-title">
          <strong>Contact Us</strong>
        </div>

        <div className="contactus-main">
          If you have any feedback for us or any partnership opportunities, we
          would like to hear from you! You can reach out to us over call, email
          or WhatsApp. Alternatively, you may also leave us your details and we
          will get in touch with you as soon as we can.
        </div>

        <div className="contactus-icon">
          <div>
            <FontAwesomeIcon icon={faPhone} style={{ fontSize: "35px" }} />
            <span className="phone-tooltip">
              Contact No : 017-3750 336
              <br />
              Working Hour :
              <br />
              Monday - Friday : 9.00 am - 6.00 pm
              <br />
              Saturday : 9.00 am - 1.00 pm
            </span>
          </div>
          <div>
            <a
              href="https://api.whatsapp.com/send/?phone=60173750336&text&type=phone_number&app_absent=0"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <FontAwesomeIcon icon={faWhatsapp} style={{ fontSize: "40px" }} />
              <span className="whatsapp-tooltip">Whatsapp : 017-3750 336</span>
            </a>
          </div>
          <div>
            <a
              href="mailto:crm@unity.net.my"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <FontAwesomeIcon icon={faEnvelope} style={{ fontSize: "40px" }} />
              <span className="email-tooltip">Email : crm@unity.net.my</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
